<template>
  <div class="fill-height">
    <radial-bar-chart
      class="fill-height"
      :series="[ getStatValue('CALETLDLHSR_G') || 0 ]"
      :plot-options="{
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          dataLabels: {
            name: {
              show: false
            },
            value: {
              offsetY: getStatValue('CALETLDLHSR') ? -2 : 25,
              fontSize: '24px'
            },
            total: {
              show: true,
              label: getStatValue('CALETLDLHSR'),
              formatter: () => getStatValue('CALETLDLHSR') ? getStatValue('CALETLDLHSR') : 'N/A'
            }
          }
        }
      }"
      :tooltip="{
        enabled: true,
        y: {
          formatter: () => `${getStatValue('CALETLDLHSR_G')}%`,
          title: {
            formatter: () => getVariableName('CALETLDLHSR_G') + ':'
          }
        }
      }"
      :animations="{enabled: false}"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t("card_title.high_speed_running") }} ({{ getVariableSuffix('CALETLDLHSR') }}){{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
        </v-card-title>
      </template>
    </radial-bar-chart>
  </div>
</template>

<script>
import RadialBarChart from '@/components/charts/RadialBarChart.vue'

export default {
  name: 'HighSpeedRunningRadialChart',
  components: { RadialBarChart },
  props: {
    stats: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    variables: {
      type: Array,
      required: true
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  methods: {
    getVariableName(value) {
      return this.$t(`variables.${value}`)
    },
    getVariableSuffix(value) {
      return this.variables.find(variable => variable.value === value)?.suffix
    },
    getKeyWithAggregation(key) {
      return this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
    },
    getStatValue(key) {
      const aggregatedKey = this.getKeyWithAggregation(key)
      return this.stats[aggregatedKey]
    }
  }
}
</script>
